import React, { useState } from 'react';
import GamesFiltersOpenings from './GamesFiltersOpenings';
import GamesFiltersTimeControls from './GamesFiltersTimeControls';
import GamesFiltersUser from './GamesFiltersUser';
import GamesFiltersDates from './GamesFiltersDates';
import GamesFiltersToggles from './GamesFiltersToggles';
import GamesCommentSearch from './GamesCommentSearch';
import { Card, Col, Collapse, FormGroup, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import GamesFiltersPlatform from './GamesFiltersPlatform';
import GamesFiltersColor from './GamesFiltersColor';
import GamesFiltersResult from './GamesFiltersResult';
import GamesFiltersRating from './GamesFiltersRating';
import GamesFiltersPattern from './GamesFiltersPattern';
import { useAppSelector } from '../store';

export default function GamesFilters(): React.ReactNode {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const { username } = useAppSelector((state) => state.paramsReducer.params);

  // "Played as" and "Result" are relative to a player — they mean nothing until
  // there's a handle to resolve them against, so they only appear once there is one.
  const hasUsername = username != null && username != '';

  return (
    <Card className="mb-3">
      <Card.Body className="bg-black">
        <FormGroup>
          {/* Primary filters — the ones used on nearly every visit. */}
          <Row className="g-3 align-items-end">
            <Col xs="auto">
              <GamesFiltersPlatform />
            </Col>
            <Col xs>
              <GamesFiltersUser />
            </Col>
            {hasUsername ? (
              <>
                {/* Force the player field onto its own line below md so the
                    result/color toggles don't squeeze it. Inline on desktop. `p-0` because the
                    breaker is a row child and would otherwise collect a gutter of its own, doubling
                    the gap above "Played as". */}
                <div className="w-100 d-md-none p-0" />
                <Col xs="auto">
                  <GamesFiltersColor />
                </Col>
                <Col xs="auto">
                  <GamesFiltersResult />
                </Col>
              </>
            ) : null}
          </Row>

          {/* Advanced filters — collapsed by default (used less often). */}
          <div className="cm-advanced-filters">
            <button
              type="button"
              className="cm-advanced-toggle"
              aria-expanded={showAdvanced}
              onClick={() => setShowAdvanced((s) => !s)}
            >
              <FontAwesomeIcon icon={faSliders} className="me-2" />
              Advanced filters
              <FontAwesomeIcon
                icon={faChevronDown}
                className={`ms-2 cm-advanced-caret${showAdvanced ? ' open' : ''}`}
              />
            </button>
            <Collapse in={showAdvanced}>
              <div>
                <Row className="g-3 align-items-end pt-3">
                  <Col xs={12} md={6}>
                    <GamesFiltersOpenings />
                  </Col>
                  {/* Speed + exact time control merged into one grouped dropdown. */}
                  <Col xs={12} md={6}>
                    <GamesFiltersTimeControls />
                  </Col>
                  <Col xs={12} md={6}>
                    <GamesFiltersPattern />
                  </Col>
                  <Col xs={12} md={6}>
                    <GamesFiltersRating />
                  </Col>
                  <Col xs={12} md={6}>
                    <GamesCommentSearch />
                  </Col>
                  <Col xs={12} md={6}>
                    <GamesFiltersDates />
                  </Col>
                  <Col xs={12}>
                    <GamesFiltersToggles />
                  </Col>
                </Row>
              </div>
            </Collapse>
          </div>
        </FormGroup>
      </Card.Body>
    </Card>
  );
}
